;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="5c810ffd-1190-4771-989a-111475a649f2",e._sentryDebugIdIdentifier="sentry-dbid-5c810ffd-1190-4771-989a-111475a649f2")}catch(e){}}();
"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1193],{

/***/ 61193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ apiURL; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(72760);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(52621);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _assets_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34648);
/* harmony import */ var _components_base_SappDrawer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63721);
/* harmony import */ var _components_base_select_HookFormSelect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88012);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45332);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55514);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82684);
/* harmony import */ var src_hooks_use_dynamic__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79350);
/* harmony import */ var src_pages_api_courses__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38916);
/* harmony import */ var _components_base_skeleton_TextSkeleton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27869);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10103);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var src_common_NoData__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(13891);
/* harmony import */ var src_pages_api_upload__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(95986);
/* eslint-disable react-hooks/exhaustive-deps */ 














var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_5___default()().publicRuntimeConfig;
var apiURL = publicRuntimeConfig.apiURL;




var DEFAULT_PAGE_INDEX = 1;
var DEFAULT_PAGESIZE = 20;
var LearningResource = function(param) {
    var open = param.open, setOpenResource = param.setOpenResource;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(), resources = ref1[0], setResources = ref1[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), selectedSection = ref2[0], setSelectedSection = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), selectedSubsection = ref3[0], setSelectedSubsection = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), selectedUnit = ref4[0], setSelectedUnit = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), selectedActivity = ref5[0], setSelectedActivity = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var handleDropdownChange = function(selectedOption, setFunction, resetFunction) {
        setFunction(selectedOption);
        // Reset the downstream dropdowns if a reset function is provided
        if (resetFunction) {
            resetFunction(null);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if ((selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value) === "") {
            setSelectedSubsection(null);
            setSelectedUnit(null);
            setSelectedActivity(null);
        }
    }, [
        selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value
    ]);
    var onClose = function() {
        document.body.style.overflow = "auto";
        setOpenResource(false);
        setSelectedSubsection(null);
        setSelectedUnit(null);
        setSelectedActivity(null);
        setSelectedSection(null);
        setPageIndex(DEFAULT_PAGE_INDEX);
        setResources(undefined);
        var pageStateVariables = [
            setPageSection,
            setPageSubsection,
            setPageUnit,
            setPageActivity, 
        ];
        pageStateVariables.forEach(function(setPageVariable) {
            setPageVariable(DEFAULT_PAGESIZE * 2);
        });
    };
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]), sections = ref7[0], setSections = ref7[1];
    function getCourseSections(page_size) {
        return _getCourseSections.apply(this, arguments);
    }
    function _getCourseSections() {
        _getCourseSections = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(page_size) {
            var ref, res, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!open) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            src_pages_api_courses__WEBPACK_IMPORTED_MODULE_9__/* .CoursesAPI.getCourseSectionList */ .tB.getCourseSectionList(router.query.courseId || router.query.id, page_size || DEFAULT_PAGESIZE)
                        ];
                    case 1:
                        res = _state.sent();
                        setSections((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sections).reverse());
                        setSelectedSubsection(null);
                        setSelectedUnit(null);
                        setSelectedActivity(null);
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _getCourseSections.apply(this, arguments);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if ((router.query.courseId || router.query.id) && open) {
            getCourseSections(DEFAULT_PAGESIZE);
        }
    }, [
        open
    ]);
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]), subSections = ref8[0], setSubsections = ref8[1];
    function getCourseSubsections(page_size) {
        return _getCourseSubsections.apply(this, arguments);
    }
    function _getCourseSubsections() {
        _getCourseSubsections = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(page_size) {
            var ref, class_id, res, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        class_id = router.query.courseId || router.query.id;
                        return [
                            4,
                            src_pages_api_courses__WEBPACK_IMPORTED_MODULE_9__/* .CoursesAPI.getCourseSubsectionList */ .tB.getCourseSubsectionList(page_size, "CHAPTER", selectedSection.value, class_id)
                        ];
                    case 1:
                        res = _state.sent();
                        setSubsections((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sections).reverse());
                        setSelectedUnit(null);
                        setSelectedActivity(null);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _getCourseSubsections.apply(this, arguments);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if ((selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value) !== "" && open) {
            getCourseSubsections(DEFAULT_PAGESIZE);
        }
    }, [
        selectedSection
    ]);
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]), unit = ref9[0], setUnit = ref9[1];
    function getCourseUnit() {
        return _getCourseUnit.apply(this, arguments);
    }
    function _getCourseUnit() {
        _getCourseUnit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
            var ref, class_id, res, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        class_id = router.query.courseId || router.query.id;
                        return [
                            4,
                            src_pages_api_courses__WEBPACK_IMPORTED_MODULE_9__/* .CoursesAPI.getCourseSubsectionList */ .tB.getCourseSubsectionList(DEFAULT_PAGESIZE, "UNIT", selectedSubsection.value, class_id)
                        ];
                    case 1:
                        res = _state.sent();
                        setUnit((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sections).reverse());
                        setSelectedActivity(null);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _getCourseUnit.apply(this, arguments);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (open) {
            getCourseUnit();
        }
    }, [
        selectedSubsection
    ]);
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]), activity = ref10[0], setActivity = ref10[1];
    function getCourseActivity(page_size) {
        return _getCourseActivity.apply(this, arguments);
    }
    function _getCourseActivity() {
        _getCourseActivity = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(page_size) {
            var ref, class_id, res, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        class_id = router.query.courseId || router.query.id;
                        return [
                            4,
                            src_pages_api_courses__WEBPACK_IMPORTED_MODULE_9__/* .CoursesAPI.getCourseSubsectionList */ .tB.getCourseSubsectionList(page_size, "ACTIVITY", selectedUnit.value, class_id)
                        ];
                    case 1:
                        res = _state.sent();
                        setActivity((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sections).reverse());
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _getCourseActivity.apply(this, arguments);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (open) {
            getCourseActivity(DEFAULT_PAGESIZE);
        }
    }, [
        selectedUnit
    ]);
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(DEFAULT_PAGE_INDEX), pageIndex = ref11[0], setPageIndex = ref11[1];
    var params = (0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .cleanParamsAPI */ .Vg)({
        sub_id: (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.value) || (selectedUnit === null || selectedUnit === void 0 ? void 0 : selectedUnit.value) || (selectedSubsection === null || selectedSubsection === void 0 ? void 0 : selectedSubsection.value) || (selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value) || "",
        page_index: DEFAULT_PAGE_INDEX,
        page_size: DEFAULT_PAGESIZE
    });
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        var initFetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
                var resources, err;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(open && (router.query.courseId || router.query.id))) return [
                                3,
                                5
                            ];
                            setLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                src_pages_api_courses__WEBPACK_IMPORTED_MODULE_9__/* .CoursesAPI.getCourseResource */ .tB.getCourseResource(router.query.courseId || router.query.id, params)
                            ];
                        case 2:
                            resources = _state.sent();
                            setPageIndex(DEFAULT_PAGE_INDEX);
                            setResources(resources.data);
                            return [
                                3,
                                5
                            ];
                        case 3:
                            err = _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setTimeout(function() {
                                setLoading(false);
                            }, 500);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function initFetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        initFetchData();
    }, [
        open,
        selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value,
        selectedSubsection === null || selectedSubsection === void 0 ? void 0 : selectedSubsection.value,
        selectedUnit === null || selectedUnit === void 0 ? void 0 : selectedUnit.value,
        selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.value, 
    ]);
    var requestOngoingRef = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(false);
    var fetchData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(nextPageIndex) {
            var res, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (requestOngoingRef.current) return [
                            2
                        ];
                        requestOngoingRef.current = true;
                        params.page_index = nextPageIndex;
                        return [
                            4,
                            src_pages_api_courses__WEBPACK_IMPORTED_MODULE_9__/* .CoursesAPI.getCourseResource */ .tB.getCourseResource(router.query.courseId || router.query.id, params)
                        ];
                    case 2:
                        res = _state.sent();
                        if (resources && (res === null || res === void 0 ? void 0 : res.data.resources)) {
                            setResources(function(prevResources) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, prevResources), {
                                    resources: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(prevResources.resources).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(res.data.resources))
                                });
                            });
                            setPageIndex(nextPageIndex);
                            requestOngoingRef.current = false;
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setTimeout(function() {
                            setLoading(false);
                        }, 500);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData(nextPageIndex) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        var divElement = document.getElementById("sapp-drawer-resource-list");
        if (!divElement) return;
        var handleScroll = function() {
            var scrollTop = divElement.scrollTop, scrollHeight = divElement.scrollHeight, clientHeight = divElement.clientHeight;
            if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
                if ((router.query.courseId || router.query.id) && open) {
                    var ref;
                    var nextPageIndex = pageIndex + 1;
                    if (Number(resources === null || resources === void 0 ? void 0 : (ref = resources.meta) === null || ref === void 0 ? void 0 : ref.total_pages) >= nextPageIndex) {
                        fetchData(nextPageIndex);
                    }
                }
            }
        };
        divElement.addEventListener("scroll", handleScroll);
        // Cleanup function
        return function() {
            divElement.removeEventListener("scroll", handleScroll);
        };
    }, [
        fetchData,
        pageIndex
    ]);
    var DEFAULT_SELECT = [
        {
            label: "All Section",
            value: ""
        }
    ];
    var download = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(name, file_key) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            src_pages_api_upload__WEBPACK_IMPORTED_MODULE_13__/* .UploadAPI.downloadFile */ .h.downloadFile({
                                files: [
                                    {
                                        name: name,
                                        file_key: file_key
                                    }
                                ]
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function download(name, file_key) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref12 = (0,src_hooks_use_dynamic__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(getCourseSections, DEFAULT_PAGESIZE), handleMenuScrollToSections = ref12.handleMenuScrollToBottom, setPageSection = ref12.setPage;
    var ref13 = (0,src_hooks_use_dynamic__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(getCourseSubsections, DEFAULT_PAGESIZE), handleMenuScrollToSubsections = ref13.handleMenuScrollToBottom, setPageSubsection = ref13.setPage;
    var ref14 = (0,src_hooks_use_dynamic__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(getCourseUnit, DEFAULT_PAGESIZE), handleMenuScrollToUnit = ref14.handleMenuScrollToBottom, setPageUnit = ref14.setPage;
    var ref15 = (0,src_hooks_use_dynamic__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(getCourseActivity, DEFAULT_PAGESIZE), handleMenuScrollToActivity = ref15.handleMenuScrollToBottom, setPageActivity = ref15.setPage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_SappDrawer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        drawerSubId: "-resource-list",
        isOpen: open,
        message: "Bạn c\xf3 chắc ch\xe1n muốn hủy kh\xf4ng?",
        onClose: onClose,
        title: "Resource",
        footer: false,
        confirmOnClose: false,
        heightBody: "h-[calc(100vh-112px)]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-2 grid grid-cols-2 gap-4 md:gap-6 xl:grid-cols-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_select_HookFormSelect__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        classParent: "w-full md:max-w-full",
                        placeholder: "Section",
                        isClearable: true,
                        value: selectedSection,
                        onChange: function(selectedOption) {
                            return handleDropdownChange(selectedOption, setSelectedSection, setSelectedSubsection);
                        },
                        options: sections && DEFAULT_SELECT.concat(sections === null || sections === void 0 ? void 0 : sections.map(function(section) {
                            return {
                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        title: section.name,
                                        children: section.name
                                    })
                                }).props.children,
                                value: section.id
                            };
                        })),
                        onMenuScrollToBottom: handleMenuScrollToSections
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_select_HookFormSelect__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        classParent: "w-full md:max-w-full",
                        placeholder: "Subsection",
                        isClearable: true,
                        value: selectedSubsection,
                        onChange: function(selectedOption) {
                            return handleDropdownChange(selectedOption, setSelectedSubsection, setSelectedUnit);
                        },
                        options: selectedSection ? subSections === null || subSections === void 0 ? void 0 : subSections.map(function(section) {
                            return {
                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        title: section.name,
                                        children: section.name
                                    })
                                }).props.children,
                                value: section.id
                            };
                        }) : [],
                        isDisabled: (selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value) === "",
                        onMenuScrollToBottom: handleMenuScrollToSubsections
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_select_HookFormSelect__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        classParent: "w-full md:max-w-full",
                        placeholder: "Unit",
                        isClearable: true,
                        value: selectedUnit,
                        onChange: function(selectedOption) {
                            return handleDropdownChange(selectedOption, setSelectedUnit, setSelectedActivity);
                        },
                        options: selectedSubsection ? unit === null || unit === void 0 ? void 0 : unit.map(function(section) {
                            return {
                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        title: section.name,
                                        children: section.name
                                    })
                                }).props.children,
                                value: section.id
                            };
                        }) : [],
                        isDisabled: (selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value) === "",
                        onMenuScrollToBottom: handleMenuScrollToUnit
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_select_HookFormSelect__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        classParent: "w-full md:max-w-full",
                        placeholder: "Activity",
                        isClearable: true,
                        value: selectedActivity,
                        onChange: function(selectedOption) {
                            return handleDropdownChange(selectedOption, setSelectedActivity, null);
                        },
                        options: selectedUnit ? activity === null || activity === void 0 ? void 0 : activity.map(function(section) {
                            return {
                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        title: section.name,
                                        children: section.name
                                    })
                                }).props.children,
                                value: section.id
                            };
                        }) : [],
                        isDisabled: (selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.value) === "",
                        onMenuScrollToBottom: handleMenuScrollToActivity
                    })
                ]
            }),
            !(0,lodash__WEBPACK_IMPORTED_MODULE_11__.isEmpty)(resources === null || resources === void 0 ? void 0 : resources.resources) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_skeleton_TextSkeleton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                loading: loading,
                length: 10,
                children: resources === null || resources === void 0 ? void 0 : (ref = resources.resources) === null || ref === void 0 ? void 0 : ref.map(function(resource) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-6 flex h-[92px] items-center justify-between p-6 last:mb-6",
                            style: {
                                border: "1px solid #DCDDDD"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-base font-normal text-bw-1",
                                            children: resource === null || resource === void 0 ? void 0 : resource.name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-base font-normal text-gray-1",
                                            children: (0,_utils_index__WEBPACK_IMPORTED_MODULE_4__/* .bytesToKilobyte */ .gv)(resource === null || resource === void 0 ? void 0 : resource.size)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "cursor-pointer",
                                    onClick: function() {
                                        return download(resource.name, resource.file_key);
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .DownloadIcon */ ._8, {})
                                })
                            ]
                        })
                    }, resource.id);
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex min-h-[calc(100vh-12rem)] items-center justify-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_common_NoData__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LearningResource);


/***/ }),

/***/ 95986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ UploadAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51224);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73782);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72760);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52621);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68582);
/* harmony import */ var _services_requestV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91002);








var UploadAPI = /*#__PURE__*/ function() {
    "use strict";
    function UploadAPI() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, UploadAPI);
    }
    UploadAPI.startUpload = function startUpload(param) {
        var content_type = param.content_type, name = param.name, size = param.size, blob = param.blob, description = param.description, getProgress = param.getProgress, location = param.location;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var responsePreUpload, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            preUpload({
                                content_type: content_type,
                                name: name || "",
                                location: location || "",
                                size: size
                            })
                        ];
                    case 1:
                        responsePreUpload = _state.sent();
                        return [
                            4,
                            uploadFile({
                                upload_url: responsePreUpload.data.upload_url,
                                file_key: responsePreUpload.data.file_key,
                                type: responsePreUpload.data.type,
                                contentType: content_type,
                                blob: blob
                            }, getProgress)
                        ];
                    case 2:
                        _state.sent();
                        // const response = await addFileResource({
                        //   name,
                        //   file_key: responsePreUpload.data.file_key,
                        //   location: location || '',
                        //   description,
                        //   size,
                        //   parent_id: null,
                        // })
                        // return response?.data?.[0]?.id
                        return [
                            2,
                            responsePreUpload
                        ];
                    case 3:
                        error = _state.sent();
                        throw error;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return UploadAPI;
}();
UploadAPI.downloadFile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(data) {
        var ref, responseToken, ref1, link, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("resource/get-token-download", {
                            data: data,
                            method: "POST"
                        })
                    ];
                case 1:
                    responseToken = _state.sent();
                    if (responseToken === null || responseToken === void 0 ? void 0 : (ref = responseToken.data) === null || ref === void 0 ? void 0 : ref.success) {
                        ;
                        link = document.createElement("a");
                        link.href = "".concat((0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .getBaseUrl */ .SV)(), "/resource/download?token=").concat(responseToken === null || responseToken === void 0 ? void 0 : (ref1 = responseToken.data) === null || ref1 === void 0 ? void 0 : ref1.data);
                        link.download = data.files[0].name;
                        link.style.display = "none";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function(data) {
        return _ref.apply(this, arguments);
    };
}();
UploadAPI.getUrlFile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(file_key) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("resource/pre-upload/url", {
                    params: {
                        file_key: file_key
                    }
                })
            ];
        });
    });
    return function(file_key) {
        return _ref.apply(this, arguments);
    };
}();
var preUpload = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var content_type, name, location, size;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            content_type = param.content_type, name = param.name, location = param.location, size = param.size;
            return [
                2,
                (0,_services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._i)("resource/pre-upload/metadata", {
                    params: {
                        content_type: content_type,
                        name: name,
                        location: location,
                        size: size
                    }
                })
            ];
        });
    });
    return function preUpload(_) {
        return _ref.apply(this, arguments);
    };
}();
var percent = 0;
var uploadFile = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(file, getProgress) {
        var fileBlob, onUploadProgress, error, startResp, startMultipartResponse, uploadId, metadata, parts, batchSize, uploadPartsArray, error1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    fileBlob = file.blob;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        ,
                        11
                    ]);
                    if (!(file.type === "SINGLE_PART")) return [
                        3,
                        6
                    ];
                    onUploadProgress = function(progressEvent) {
                        var percent = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                        if (getProgress) {
                            getProgress(percent);
                        }
                    };
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].put */ .Z.put(file.upload_url, fileBlob, {
                            headers: {
                                "Content-Type": fileBlob.type
                            },
                            onUploadProgress: onUploadProgress
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    throw error;
                case 5:
                    return [
                        2
                    ];
                case 6:
                    return [
                        4,
                        _services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/resources/upload/start", {
                            file_key: file.file_key,
                            content_type: fileBlob.type,
                            size: fileBlob.size
                        })
                    ];
                case 7:
                    startResp = _state.sent();
                    startMultipartResponse = startResp.data.data;
                    uploadId = startMultipartResponse.uploadId, metadata = startMultipartResponse.metadata, parts = startMultipartResponse.parts;
                    batchSize = 2;
                    percent = 0;
                    return [
                        4,
                        uploadMultipart((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            batchSize: batchSize,
                            chunkSize: metadata.partSize,
                            fileBlob: fileBlob,
                            numberOfChunks: metadata.numberOfParts,
                            parts: parts
                        }, getProgress ? {
                            getProgress: getProgress
                        } : {
                            getProgress: function() {}
                        }))
                    ];
                case 8:
                    uploadPartsArray = _state.sent();
                    return [
                        4,
                        _services_requestV2__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/resources/upload/complete", {
                            file_key: file.file_key,
                            parts: uploadPartsArray,
                            uploadId: uploadId
                        })
                    ];
                case 9:
                    _state.sent();
                    return [
                        3,
                        11
                    ];
                case 10:
                    error1 = _state.sent();
                    throw error1;
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return function uploadFile(file, getProgress) {
        return _ref.apply(this, arguments);
    };
}();
function uploadMultipart(params, source) {
    return _uploadMultipart.apply(this, arguments);
}
function _uploadMultipart() {
    _uploadMultipart = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(params, source) {
        var chunkSize, numberOfChunks, fileBlob, batchSize, parts, getProgress, index, partNumbers, batchUploadPromises, batchElementIndex, batchUploadResults, partsUploadResults, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, result, _value, response, part_number, nextPartsUploadResults;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chunkSize = params.chunkSize, numberOfChunks = params.numberOfChunks, fileBlob = params.fileBlob, batchSize = params.batchSize, parts = params.parts, getProgress = params.getProgress;
                    index = params.index === undefined ? 0 : params.index;
                    partNumbers = parts.map(function(part) {
                        return part.part_number;
                    });
                    batchUploadPromises = [];
                    batchElementIndex = 0;
                    while(batchElementIndex < batchSize && index < numberOfChunks){
                        var ref;
                        index += 1;
                        batchElementIndex += 1;
                        var start = (index - 1) * chunkSize;
                        var end = index * chunkSize;
                        var blob = index < numberOfChunks ? fileBlob.slice(start, end) : fileBlob.slice(start);
                        var uploadUrl = (ref = parts[partNumbers.indexOf(index)]) === null || ref === void 0 ? void 0 : ref.upload_url;
                        try {
                            var uploadPromise = getUploadPromise({
                                blob: blob,
                                contentType: fileBlob.type,
                                index: index,
                                uploadUrl: uploadUrl,
                                fileSize: fileBlob.size,
                                chunkSize: blob.size,
                                getProgress: getProgress
                            }, source);
                            batchUploadPromises.push(uploadPromise);
                        } catch (error) {
                            throw error;
                        }
                    }
                    return [
                        4,
                        Promise.allSettled(batchUploadPromises)
                    ];
                case 1:
                    batchUploadResults = _state.sent();
                    partsUploadResults = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = batchUploadResults[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            result = _step.value;
                            if (result.status === "fulfilled") {
                                _value = result.value, response = _value.response, part_number = _value.index;
                                partsUploadResults.push({
                                    eTag: response.headers.etag,
                                    part_number: part_number
                                });
                            } else {
                                throw new Error("One request failed: " + result.reason);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!(index < numberOfChunks)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        uploadMultipart((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, params), {
                            index: index
                        }))
                    ];
                case 2:
                    nextPartsUploadResults = _state.sent();
                    return [
                        2,
                        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(partsUploadResults).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(nextPartsUploadResults))
                    ];
                case 3:
                    return [
                        2,
                        partsUploadResults
                    ];
            }
        });
    });
    return _uploadMultipart.apply(this, arguments);
}
function getUploadPromise(params, source) {
    var blob = params.blob, index = params.index, uploadUrl = params.uploadUrl, contentType = params.contentType, getProgress = params.getProgress, fileSize = params.fileSize, chunkSize = params.chunkSize;
    return new Promise(function(resolve, reject) {
        if (!uploadUrl) {
            reject("Upload url is empty at part_number: " + index);
        } else {
            axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].put */ .Z.put(uploadUrl, blob, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                headers: {
                    "Content-Type": contentType
                }
            }, source && {
                cancelToken: source.token
            })).then(function(response) {
                var percentCompleted = Math.round(chunkSize / fileSize * 100);
                percent += percentCompleted;
                getProgress(percent >= 100 ? 100 : percent);
                resolve({
                    response: response,
                    index: index
                });
            }).catch(function(error) {
                source && source.cancel("One request failed, canceling all the others");
                getProgress(100);
                reject(error);
            });
        }
    });
}


/***/ })

}]);